var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Checkbox } from 'antd';
class CheckboxNumber extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    handleInputChange(e) {
        e.target.checked = e.target.checked ? 1 : 0;
        this.props.onChange && this.props.onChange(e);
    }
    render() {
        const _a = this.props, { checked, value, onChange, children } = _a, otherProps = __rest(_a, ["checked", "value", "onChange", "children"]);
        return (<Checkbox checked={checked || value ? true : false} onChange={this.handleInputChange} {...otherProps}>
                {children}
            </Checkbox>);
    }
}
CheckboxNumber.defaultProps = {
    onChange: () => { },
};
export default CheckboxNumber;
